import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import BASE_URL, { getImageURL } from '../../config';
import '../ShopByCategory.css';

const ShopByCategoryDe = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${BASE_URL}/api/categories/?format=json`)
      .then((res) => {
        setCategories(res.data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  if (loading || !categories.length) return null;

  const getAbbreviation = (name) => {
    const words = name.split(' ');
    if (words.length >= 2) {
      return (words[0][0] + words[1][0]).toUpperCase();
    }
    return name.slice(0, 2).toUpperCase();
  };

  return (
    <div className="container sbc-section">
      <h2 className="sbc-title">Nach Kategorie einkaufen</h2>
      <div className="sbc-grid">
        {categories.map((cat) => (
          <Link key={cat.id} to={`/categories/${cat.slug}`} className="sbc-card">
            {cat.icon ? (
              <img src={getImageURL(cat.icon)} alt={cat.name} className="sbc-icon-img" />
            ) : (
              <span className="sbc-abbr">{getAbbreviation(cat.name)}</span>
            )}
            <span>{cat.name}</span>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default ShopByCategoryDe;
